import { useCallback } from 'react';

const ACTIVATABLE = 'input[type="checkbox"]:not([disabled]), button:not([disabled])';
const OWN_ENTER_BEHAVIOR = 'button, a, [role="button"], textarea';

/**
 * AIDEV-NOTE: Two keyboard defaults the manager has to restore or suppress itself.
 *
 * Space: something on the admin section pages cancels the Space keydown, so the browser never toggles
 * a checkbox or activates a button in the manager (PLAT-17662 — the legacy tag inputs on those pages
 * are likely affected too). Activating explicitly makes the manager independent of it, and we always
 * preventDefault so this can't double-fire if that page-level handler is ever removed. Auto-repeat is
 * skipped so a held Space activates once, like the native control (PLAT-18305).
 *
 * Enter: the manager mounts inside real edit forms (admin/sections/edit, admin/notebooks,
 * exercise_builder), where Enter on a checkbox or the search box submits the form. Buttons and links
 * are exempt because for them Enter's default action IS the activation.
 */
export default function useCorrelationKeyboard() {
  return useCallback((event: React.KeyboardEvent<HTMLElement>) => {
    const target = event.target as HTMLElement;

    if (event.key === ' ') {
      const activatable = target.closest<HTMLElement>(ACTIVATABLE);
      if (!activatable) return;

      event.preventDefault();
      if (!event.repeat) activatable.click();
      return;
    }

    if (event.key !== 'Enter' || target.closest(OWN_ENTER_BEHAVIOR)) return;

    event.preventDefault();
  }, []);
}
